import { call, put, takeLatest } from 'redux-saga/effects';
import { getActiveRelations, getRelations } from '../../services/API';
import {
  getActiveRelationsError,
  getActiveRelationsSuccess,
  getRelationsError,
  getRelationsSuccess,
} from 'modules/Profile/redux/relations/actions';
import {
  GET_ACTIVE,
  GET_RELATIONS,
  UPDATE_RELATIONS,
} from 'modules/Profile/redux/relations/actionTypes';

function* getRelationsSaga({ payload }) {
  const { isOk, data, error } = yield call(getRelations, payload);
  yield put(isOk ? getRelationsSuccess(data) : getRelationsError(error));
}

// function* updateSaga({ payload: { type, data: requestData } }) {
//   const methodByType = {
//     create: createRelations,
//     confirm: confirmRelations,
//     refuse: refuseRelations,
//   };
//
//   yield put(updateRelationSuccess(type, requestData));
//
//   const { isOk, data, error } = yield call(methodByType[type], requestData);
//   yield put(isOk ? updateRelationSuccess(data) : updateRelationError(error));
// }
// TODO: remove direct list updating when BE is ready to return relation model
function* updateSaga() {
  yield getRelationsSaga({});
}

function* getActiveRelationsSaga({ payload }) {
  const { isOk, data, error } = yield call(getActiveRelations, payload);
  yield put(isOk ? getActiveRelationsSuccess(data) : getActiveRelationsError(error));
}

export default function* relationsSaga() {
  yield takeLatest(GET_RELATIONS, getRelationsSaga);
  yield takeLatest(UPDATE_RELATIONS, updateSaga);
  yield takeLatest(GET_ACTIVE, getActiveRelationsSaga);
}
